module.exports = __webpack_public_path__ + "img/weChat.2df54159.svg";